import axios from 'axios';

const url = '/invoicingservice/api/revenue';

export const getJobRevenue = (id: string) => axios.get(`${url}/get-positions?id=${id}`);

export const getCandidaterevenue = (id: string) =>
  axios.get(`${url}/get-candidate-revenue?id=${id}`);
